import styled from "styled-components";

export const StyledSectionWrapper = styled.div`
  background-image: url("./images/teachers-trainers-bg.png");
  background-repeat: no-repeat;
  background-position: 47% 0;
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    background-size: 100% auto;
  }
`;

export const StyledSectionContent = styled.div`
  padding: 171px 8% 0;
  display: flex;
  flex-direction: column;

  & p {
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.161738px;
    margin-bottom: 17px;
    color: #fbbb17;
  }

  & h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 128px;
    color: #ffffff;
  }

  & span {
    color: #fbbb17;
  }

  & img {
    width: 100%;
    max-width: 421px;
    margin: 0 auto;
    height: auto;
    box-shadow: 0px 24px 46px rgba(0, 0, 0, 0.199574);
  }
  
  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    & img {
      margin: 0 0 -40px auto;
      width: 35%;
      min-width: 230px;
    }
  }
  
  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    & p {
      font-size: 21px;
    }
    
    & h3 {
      font-size: 56px;
      line-height: 58px;
    }
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    justify-content: space-between;
    flex-direction: row;
    align-items: flex-start;
    padding-top: 210px;
    padding-left: 65px;
    padding-right: 65px;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    
    & h3 {
      width: 560px;
    }
    
    & img {
      margin-top: 120px;
      width: 420px;
    }
  }
`;
